// Module
var code = "<div class=\"table-widget-cell flex-fill logbook-table-cell\" title=\"{{vm.entry.entryTitle}}\"> <ng-transclude></ng-transclude> <span class=\"logbook-badge top-right onhover\"> <i class=\"fa fa-fw fa-edit\" style=\"color:#000\" title=\"{{'Add logbook entry'|translate}}\" ng-click=\"vm.openModal(vm.entry, $event)\"> </i> </span> </div>";
// Exports
module.exports = code;